import { toastRemoveState } from "lib/store/common";
import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";

import "./Toast.scss";

export type ToastProps = {
  type: "success" | "error";
  idx: number;
};

export const Toast: React.FC<ToastProps> = ({ type, idx, children }) => {
  const [on, setOn] = useState(true);
  const setToast = useSetRecoilState(toastRemoveState);

  useEffect(() => {
    if (!on) return;
    setTimeout(async () => {
      await setOn((on) => {
        return !on;
      });
      await setToast(idx);
    }, 2000);
    // eslint-disable-next-line
  }, []);

  return (
    <div
      onClick={() => console.log(idx)}
      className={`Toast ${type} ${on ? "on" : "off"}`}
    >
      {children}
    </div>
  );
};
